// Fidem & Co: the small amount of behaviour the theme actually needs.
document.addEventListener('click', (e) => {
  const burger = e.target.closest('[data-burger]');
  if (burger) {
    const nav = document.getElementById('site-nav');
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', String(open));
  }

  const step = e.target.closest('[data-qty-step]');
  if (step) {
    e.preventDefault();
    const input = step.parentElement.querySelector('input');
    if (!input) return;
    const next = Number(input.value) + Number(step.dataset.qtyStep);
    input.value = Math.max(0, next);
    input.form?.requestSubmit();
  }
});

// Product page: keep the URL and the Add to bag button in step with the
// selected variant, so a shared link opens on the right one.
const form = document.querySelector('[data-variant-form]');
if (form) {
  const variants = JSON.parse(document.getElementById('variant-data').textContent);
  const idField = form.querySelector('[name="id"]');
  const submit = form.querySelector('[data-submit]');
  const priceEl = document.querySelector('[data-price]');

  form.addEventListener('change', () => {
    const chosen = [...form.querySelectorAll('input[type=radio]:checked')].map((i) => i.value);
    const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));

    if (!match) {
      submit.disabled = true;
      submit.textContent = 'Unavailable';
      return;
    }
    idField.value = match.id;
    submit.disabled = !match.available;
    submit.textContent = match.available ? 'Add to bag' : 'Sold out';
    if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;

    const url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  });
}
